import BoatAlertRecipientsLink from './alert-recipents/BoatAlertRecipientsLink'
import BoatAlertRecipientsRoute from './alert-recipents/BoatAlertRecipientsRoute'
import ESNAttribute from './attributes/ESNAttribute'
import NameAttribute from './attributes/NameAttribute'
import GlobalstarSubscriptionStatusAttribute from './attributes/GlobalstarSubscriptionStatusAttribute'
import SubscriptionHiddenDataViewer from './attributes/dataViewers/SubscriptionHiddenDataViewer'
import GlobalstarHiddenDataViewer from './attributes/dataViewers/GlobalstarHiddenDataViewer'
import ESNAttributeRenderer from './attributes/renderers/ESNAttributeRenderer'
import NameAttributeRenderer from './attributes/renderers/NameAttributeRenderer'
import SubscriptionStatusRenderer from './attributes/renderers/SubscriptionStatusRenderer'
import GlobalstarSubscriptionStatusRenderer from './attributes/renderers/GlobalstarSubscriptionStatusRenderer'
import BoatCanBusLink from './can-bus/BoatCanBusLink'
import BoatCanBusRoute from './can-bus/BoatCanBusRoute'
import BoatCommentsLink from './comments/BoatCommentsLink'
import BoatCommentsRoute from './comments/BoatCommentsRoute'
import BoatNMEALink from './nmea/BoatNMEALink'
import BoatNMEARoute from './nmea/BoatNMEARoute'
import BoatDebugLogsLink from './debugLogs/BoatDebugLogsLink'
import BoatDebugLogsRoute from './debugLogs/BoatDebugLogsRoute'
import DeviceCommandsHistoryLink from './deviceCommands/DeviceCommandsHistoryLink'
import DeviceCommandsHistoryRoute from './deviceCommands/DeviceCommandsHistoryRoute'
import FirmwareHistoryLink from './firmware/FirmwareHistoryLink'
import FirmwareHistoryRoute from './firmware/FirmwareHistoryRoute'
import WirelessSensorCreateHook from './hooks/WirelessSensorCreateHook'
import GlobalStarCreateHook from './hooks/GlobalStarCreateHook'
import EventsLogLink from './eventsLog/EventsLogLink'
import EventsLogRoute from './eventsLog/EventsLogRoute'
import SubscriptionStatusAttribute from './attributes/SubscriptionStatusAttribute'
import WirelessSensorsEventsLogsDataViewer from './attributes/dataViewers/WirelessSensorsEventsLogsDataViewer'

const install = ( molten ) => {
  // NMEA
  molten.addPlugin( 'Route', BoatNMEARoute )
  molten.addPlugin( 'Action', BoatNMEALink )
  
  // CAN
  molten.addPlugin( 'Route', BoatCanBusRoute )
  molten.addPlugin( 'Action', BoatCanBusLink )
  
  // Comments
  molten.addPlugin( 'Route', BoatCommentsRoute )
  molten.addPlugin( 'Action', BoatCommentsLink )
  
  // Alert Recipients 
  molten.addPlugin( 'Route', BoatAlertRecipientsRoute )
  molten.addPlugin( 'Action', BoatAlertRecipientsLink )

  // Boat Index Page
  molten.addPlugin( 'Attribute', ESNAttribute )
  molten.addPlugin( 'Attribute', NameAttribute )
  molten.addPlugin( 'Attribute', SubscriptionStatusAttribute )
  molten.addPlugin( 'Attribute', GlobalstarSubscriptionStatusAttribute )
  molten.addPlugin( 'DataViewer', SubscriptionHiddenDataViewer )
  molten.addPlugin( 'DataViewer', GlobalstarHiddenDataViewer )
  molten.addPlugin( 'DataViewer', WirelessSensorsEventsLogsDataViewer )
  molten.addPlugin( 'AttributeCellRenderer', ESNAttributeRenderer )
  molten.addPlugin( 'AttributeCellRenderer', NameAttributeRenderer )
  molten.addPlugin( 'AttributeValueRenderer', SubscriptionStatusRenderer )
  molten.addPlugin( 'AttributeValueRenderer', GlobalstarSubscriptionStatusRenderer )

  // Device Commands
  molten.addPlugin( 'Route', DeviceCommandsHistoryRoute )
  molten.addPlugin( 'Action', DeviceCommandsHistoryLink )
  // Firmware
  molten.addPlugin( 'Route', FirmwareHistoryRoute )
  molten.addPlugin( 'Action', FirmwareHistoryLink )

  // Events Log
  molten.addPlugin( 'Route', EventsLogRoute )
  molten.addPlugin( 'Action', EventsLogLink )

  // Debug Logs
  molten.addPlugin( 'Route', BoatDebugLogsRoute )
  molten.addPlugin( 'Action', BoatDebugLogsLink )

  // Boat sensors ItemCreateHooks
  molten.addPlugin( 'ItemCreateHook', WirelessSensorCreateHook )
  molten.addPlugin( 'ItemCreateHook', GlobalStarCreateHook )
}

export default {
  install,
}
